export const GET_ADDRESS_BASE_URL = 'https://api.getaddress.io';
export const API_KEY_QUERY_PARAM_NAME = 'api-key';
